module.exports = __webpack_public_path__ + "static/img/student.35232af4.png";